import getQuery from './get-query.action';

export default getQuery;
